import useEditTheme from './useEditTheme.hook';
import { Drawer } from '@/shared/Drawers';
import { StyledEditThemes } from './EditTheme.styled';
import ThemeActivitiesSelector from '../AddThemes/ThemeActivitiesSelector/ThemeActivitiesSelector';
import ExploreAndPlay from '@/shared/ExploreAndPlay/ExploreAndPlay';
import { StyledActionsFooter } from '@/shared/StepActionsFooter/StepActionsFooter.styled';
import Button from '@/shared/Button/Button';

export default function EditTheme({ classId, theme, onClose, onFinish }) {
  const { state, actions } = useEditTheme({
    classId,
    theme,
    onFinish,
  });

  return (
    <Drawer
      title={
        <span>
          Edit <ExploreAndPlay />
        </span>
      }
      width={'90%'}
      loading={state.loading}
      onClose={onClose}
      footer={
        <StyledActionsFooter>
          <div className="left-side"></div>
          <div className="right-side">
            <Button
              type="outlined"
              onClick={onClose}
              disabled={state.processing}
            >
              Cancel
            </Button>
            {state.loading || state.customEnabledActivities?.length ? (
              <Button
                type="primary"
                disabled={state.processing}
                loading={state.processing}
                onClick={actions.save}
              >
                Save
              </Button>
            ) : (
              <Button
                type="danger"
                onClick={actions.save}
                disabled={state.processing}
                loading={state.processing}
              >
                Delete theme
              </Button>
            )}
          </div>
        </StyledActionsFooter>
      }
    >
      <StyledEditThemes>
        {state.loading ? null : (
          <ThemeActivitiesSelector
            editorActive
            theme={theme}
            initialActivityIds={state.customEnabledActivities}
            onActivitiesSelected={(activities) =>
              actions.onCustomActivitiesSelected(
                activities.map((activity) => activity.id)
              )
            }
          />
        )}
      </StyledEditThemes>
    </Drawer>
  );
}
